import { useContext } from "react";
import { ModalV3Context } from "src/components/ModalV3/ModalV3.tsx";

export const useModalV3Context = () => {
  const context = useContext(ModalV3Context);
  if (!context) {
    throw new Error("useModalV3Context must be used as ModalV3ContextProvider");
  }
  return context;
};
